import QueryParamsUtils from '../../shared/helpers/query-params-utils';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';

interface LessonPageQueryParams {
  courseId: number;
  lessonType: StudyBundleCourseDto['lessonType'];
  unitId?: number;
  levelName?: string;
  unitName?: string;
  isFromUnitIndex? : boolean;
  isSkippingUnit?: string;
}

export class LessonPageParams {
  private params: LessonPageQueryParams;

  constructor(searchParams: string) {
    this.params = QueryParamsUtils.getQueryParamsFromHash<LessonPageQueryParams>(searchParams);
  }

  public get courseId(): number {
    return +this.params.courseId;
  }

  public get lessonType(): StudyBundleCourseDto['lessonType'] {
    return this.params.lessonType;
  }

  public get unitId(): number {
    return +this.params.unitId;
  }

  public get unitName(): string {
    return this.params.unitName;
  }

  public get levelName(): string {
    return this.params.levelName;
  }

  public get isFromUnitIndex(): boolean {
    return this.params.isFromUnitIndex;
  }

  public get isSkippingUnit(): boolean {
    return String(this.params.isSkippingUnit) === 'true';
  }
}



// WEBPACK FOOTER //
// ./ts/app/learning/lesson-page/lesson-page-params.ts